const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => window.localStorage.getItem("glow_admin_token");
export const saveToken = (token) => window.localStorage.setItem("glow_admin_token", token);
export const clearToken = () => window.localStorage.removeItem("glow_admin_token");

export async function apiRequest(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);
  if (options.body && !(options.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const response = await fetch(`${API}${path}`, { ...options, headers, credentials: "include" });
  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) {
    const detail = data?.detail;
    const message = Array.isArray(detail) ? detail.map((item) => item.msg || JSON.stringify(item)).join(" ") : detail || "Something went wrong.";
    throw new Error(message);
  }
  return data;
}
